import {IProfile} from "StateInterface";
import {FIELD_NAMES} from "profile/enums";
import {IResidenceAddressFields} from "IncompleteInfoV2/ResidenceAddress/index";
import {convertDateToMilliseconds, dateToInputString} from "IncompleteInfoV2/utils";

const getAlternateAddressValues = (profile: IProfile, fieldName: string): string | null => {
     if (profile["alternateAddresses"] && profile.alternateAddresses.length) {
        return profile.alternateAddresses[profile.alternateAddresses.length - 1][fieldName];
    }
     return null;
};

export const getInitialResidenceValue = (profile: IProfile): IResidenceAddressFields => {
    return {
        residentType: profile.residentType,
        resTenure: profile.resTenure && dateToInputString(profile.resTenure),
        street: getAlternateAddressValues(profile, FIELD_NAMES.STREET),
        house: getAlternateAddressValues(profile, FIELD_NAMES.HOUSE),
        locality: getAlternateAddressValues(profile, FIELD_NAMES.LOCALITY),
        landmark: getAlternateAddressValues(profile, FIELD_NAMES.LANDMARK),
        pincode: getAlternateAddressValues(profile, FIELD_NAMES.PINCODE),
    };
};

export  const profileUpdate = (fields: IResidenceAddressFields) => {
    const profile = {
        alternateAddresses: [],
    };
    Object.keys(fields).forEach((key) => {
        if (key === FIELD_NAMES.HOUSE ||
            key === FIELD_NAMES.LOCALITY ||
            key === FIELD_NAMES.STREET ||
            key === FIELD_NAMES.LANDMARK ||
            key === FIELD_NAMES.PINCODE) {
            profile["alternateAddresses"] = [{
                ...profile.alternateAddresses[0],
                [key]: fields[key],
            }];
        } else {
            profile[key] = key ===  FIELD_NAMES.RES_TENURE ? convertDateToMilliseconds(fields[key]) : fields[key];
        }
    });
    return profile;
};
